<template>
  <div class="pvc-tree-node">
    <div class="item-rect d-flex" :class="{grey: !isChecked}">
      <div class="d-flex flex-grow-1" style="margin-right: 20px; max-width:25%">
        <base-checkbox :disabled="isDisabled" style="margin: 8px 0 10px 0;" class="d-inline-block mb-0" v-model="value.checked" label=""></base-checkbox>
        <div class="flex-grow-1">
          <v-select :disabled="isDisabled" :value="selectedOption" :clearable="false"
                    @input="changed($event)" :options="options" placeholder="-- select --" :searchable="false" />
        </div>
      </div>
      <div class="text-right" style="max-width: 75%; width: 100%;" :style="{visibility: isChecked ? 'visible' : 'hidden'}">
        <div class="d-flex align-items-center justify-content-end" v-if="showPiPcDivision">
          <span class="mr-2 ml-auto">PI-PC</span>
          <div style="width: 110px;" class="mr-2">
            <input :disabled="isDisabled" ref="pipc" class="form-control simple text-right" v-input-mask data-inputmask-mask="9{1,3}-9{1,3}%" v-model="pipc" />
          </div>
          <div class="mr-4 d-flex align-items-center">
            <span class="mr-3">PI</span>
            <div class="flex-grow-1">
              <vue-slider :disabled="isDisabled" style="width: 100px;" v-model="value.postindustrial"></vue-slider>
            </div>
            <div>
              <span class="ml-3">PC</span>
            </div>
          </div>
          <div class="mr-2 d-flex align-items-center">
            <span class="mr-3">Overall</span>
            <div style="width: 80px;" class="mr-2">
              <input
                :disabled="isDisabled"
                class="form-control simple text-right"
                v-input-mask data-inputmask-mask="9{1,3}%"
                v-model="overall"
              />
            </div>
          </div>

          <div class="mr-4 d-flex align-items-center">
            <span class="mr-3">PI</span>
            <div class="flex-grow-1">
              <vue-slider
                ref="slider"
                :disabled="isDisabled"
                style="width: 100px;"
                v-model="value.percentage"
                @change="setCorrectMaxPosiblePercent('percentage')"
                @drag-end="onDragEnd('percentage')"
              ></vue-slider>
            </div>
            <div>
              <span class="ml-3">PC</span>
            </div>
          </div>
        </div>

        <div class="d-flex align-items-center justify-content-end" v-if="showPiPcDivision === false">
          <div class="mr-4 d-flex align-items-center">
            <div class="flex-grow-1">
              <vue-slider
                ref="slider"
                :disabled="isDisabled"
                style="width: 100px;"
                v-model="value.percentage"
                @change="setCorrectMaxPosiblePercent('percentage')"
                @drag-end="onDragEnd('percentage')"
              ></vue-slider>
            </div>
            <div style="width: 80px;" class="mr-2">
              <input
                :disabled="isDisabled"
                class="form-control simple text-right"
                style="border-bottom: 0;"
                v-input-mask data-inputmask-mask="9{1,3}%"
                v-model="overall"
              />
            </div>
            <div>
              <span class="mr-3"> of overall composition</span>
            </div>
          </div>
        </div>

      </div>
    </div>
    <span v-if="!isDisabled" class="delete-item" @click="deleteOtherItem()">
      <i class="fas fa-times"></i>
    </span>
  </div>
</template>

<script>

  import BaseCheckbox from '../checkbox/BaseCheckbox';
  import vSelect from 'vue-select';

  export default {
    name: 'PvcListItem',
    props: {
      value: {
        type: Object,
        default: () => {}
      },
      data: {
        type: Object,
        default: () => {}
      },
      options: {
        type: Array,
        default: () => []
      },
      totalPercentage: {
        type: Number,
        default: () => 0,
      },
      showPiPcDivision: {
        type: Boolean,
        default: true,
      }
    },
    data () {
      return {
        checked: false,
        postconsumer: 0
      };
    },
    mounted () {
      if (typeof this.value !== 'undefined') {
        this.postconsumer = 100 - this.value.postindustrial;
        this.checked = this.value.checked;
      }
    },
    watch: {
      'value.postindustrial': function(newValue) {
          this.postconsumer = 100 - newValue;
      },
      'value.checked': function(newValue) {
          this.checked = newValue;
      }
    },
    computed: {
      selectedOption () {
        return this.options.find(x => x.id === this.value.sub_composition_id);
      },
      pipc: {
        get () {
          return this.value.postindustrial + '-' + this.postconsumer + '%';
        },
        set (value) {
          const selection = this.$refs.pipc.selectionStart ? this.$refs.pipc.selectionStart : 0;
          // eslint-disable-next-line
          let dp = sanitizeDoublePercents(value, selection);
          this.value.postindustrial = dp.postindustrial;
          this.$nextTick(() => {
            this.$refs.pipc.selectionStart = selection;
            this.$refs.pipc.selectionEnd = selection;
          });
        }
      },
      overall: {
        get () {
          return this.value.percentage + '%';
        },
        set (value) {
          // eslint-disable-next-line
          this.value.percentage = sanitizePercents(value);
          this.setCorrectMaxPosiblePercent('percentage');
        }
      },
      isChecked() {
        return this.checked;
      },
      id () {
        return 'base-pvc-list-item-' + this._uid;
      },
      isDisabled () {
        return !!this.composition.id;
      },
      composition: {
        get () {
          return this.$store.getters['userCompositions/current'];
        },
        set (value) {
          this.$store.commit('userCompositions/current', value);
        }
      },
    },
    methods: {
      onDragEnd(name) {
        this.$refs.slider.setValue(this.value[name]);
      },
      setCorrectMaxPosiblePercent(name) {
        if (typeof this[name] === 'string') {
            this[name] = 0;
          return;
        }
        setTimeout(() => {
          if (this.totalPercentage > 100) {

            const newValue = this.value[name] - (this.totalPercentage - 100);

            this.value[name] = newValue;
            // this.$refs.slider.setValue(newValue)
          }
        }, 0);
      },
      deleteOtherItem() {
        this.$store.dispatch('userCompositions/removeOther', this.value);
      },
      changed(event) {
        this.value.sub_composition_id = event.id;
      }
    },
    components: {
      BaseCheckbox, vSelect
    },
  };

</script>

<style>

</style>
